const SaveButtonHook = {
  mounted() {
    this.el.addEventListener("click", (event) => {
      // Prevent the default phx-click behavior
      event.preventDefault();
      event.stopPropagation();
      
      // Find the associated textarea
      const blockId = this.el.getAttribute('phx-value-block_id');
      const sectionId = this.el.getAttribute('phx-value-section_id');
      
      let textarea;
      if (blockId) {
        textarea = document.getElementById(`block-text-${blockId}`);
      } else if (sectionId) {
        textarea = document.getElementById(`section-text-${sectionId}`);
      } else {
        // This is the filter text case
        textarea = document.getElementById('filter-text');
      }
      
      if (textarea && textarea.saveContent) {
        // Call the saveContent method on the textarea
        textarea.saveContent();
      }
    });
  }
};

export default SaveButtonHook;
